import React, { lazy, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ModalStore, { closeModal } from 'lib/stores/modalStore';
import Modal from 'lib/components/Modal';

const ResidentDocumentsForm = lazy(() => import('lib/components/Forms/Host/ResidentDocuments'));

const ResidentDocumentsModal = ({ disableCovidQuestions }) => {
  const { open, data: { resident = {} } } = ModalStore.useState(state => state.residentDocumentsModal);

  const closeResidentDocumentsModal = () => {
    ModalStore.update(state => closeModal(state, 'residentDocuments'));
  };

  return (
    <Modal
      title="Upload Resident Documents"
      onClose={closeResidentDocumentsModal}
      acceptMessage="Submit"
      open={open}
      id="residentDocumentsModal"
    >
      <ErrorBoundary fallback={<div>Error loading documents</div>}>
        <Suspense fallback={<div>Loading documents form...</div>}>
          <ResidentDocumentsForm
            key={resident.id}
            resident={resident}
            onAfterSubmit={closeResidentDocumentsModal}
            disableCovidQuestions={disableCovidQuestions}
          />
        </Suspense>
      </ErrorBoundary>
    </Modal>
  );
};

export default ResidentDocumentsModal;
